import { render } from 'preact';
import { App } from './app';

const root = document.querySelectorAll('[x-search]');

if (root.length > 0) {
  root.forEach((el) => {
    render(<App />, el);
  });
}
